import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import List from "./list";
import ListDetailsSubLayout from "../../layout/ListDetailSubLayout";
import Details from "./details";
import useCommonStore from "../../stores/common";
import useOrganizationStore from "../../stores/organization";
import useUserStore from "../../stores/user";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import CloseIconWhite from "../../assets/svg/icons/common/CloseIconWhite";
import style from "./styles.module.scss";
import AddOrganizationModal from "./components/add-organization-modal";
import WhitelabelSettingsModal from "./components/whitelabel-settings-modal";
import { isEntitySuperAdmin } from "../../../components/helper/helper";

const OrganizationsPage = ({ history }) => {
  const organizationId = useUserStore((state) => state.organizationId);
  const user = useUserStore((state) => state.user);
  const userLoading = useUserStore((state) => state.userLoading);
  const addOrganizationModalOpen = useOrganizationStore(
    (state) => state.addOrganizationModalOpen,
  );
  const setAddOrganizationModalOpen = useOrganizationStore(
    (state) => state.setAddOrganizationModalOpen,
  );
  const editOrganization = useOrganizationStore(
    (state) => state.editOrganization,
  );
  const whitelabelModalOpen = useOrganizationStore(
    (state) => state.whitelabelModalOpen,
  );
  const setWhitelabelModalOpen = useOrganizationStore(
    (state) => state.setWhitelabelModalOpen,
  );
  useEffect(() => {
    if (userLoading || !user) return;

    if (!isEntitySuperAdmin(user) && organizationId) {
      history.replace(`/v2/organizations/${organizationId}`);
    }

    return () => {
      useCommonStore.getState().reset();
      useOrganizationStore.getState().reset();
    };
  }, [user, userLoading, organizationId, history]);

  if (userLoading || !user) {
    return null;
  }

  if (!isEntitySuperAdmin(user)) {
    return null;
  }

  return (
    <>
      <ListDetailsSubLayout listComponent={List} detailsComponent={Details} />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    className={style.toast_dismissal_button}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <CloseIconWhite />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>

      {addOrganizationModalOpen && (
        <AddOrganizationModal
          open={addOrganizationModalOpen}
          onClose={() => setAddOrganizationModalOpen(false)}
          isEdit={editOrganization}
        />
      )}

      {whitelabelModalOpen && (
        <WhitelabelSettingsModal
          open={whitelabelModalOpen}
          onClose={() => setWhitelabelModalOpen(false)}
        />
      )}
    </>
  );
};

export default withRouter(OrganizationsPage);
